<script>
export default {
    page() {
        const channelTitle = this.channel.title || 'Channel'
        const title = `History — ${channelTitle}`
        const description = `Recently played mixes on ${channelTitle}.`
        const image = `${import.meta.env.VITE_CLIENT_URL}/frisky-social-share-image.png`
        const canonicalUrl = `https://frisky.fm${this.$route.path}`
        return {
            title,
            link: [{ rel: 'canonical', vmid: 'canonical', href: canonicalUrl }],
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },
                { property: 'og:image', vmid: 'og:image', content: image },
                { property: 'og:type', vmid: 'og:type', content: 'website' },
                { property: 'og:url', vmid: 'og:url', content: canonicalUrl },
                { property: 'og:site_name', vmid: 'og:site_name', content: 'FRISKY' },

                { name: 'twitter:card', vmid: 'twitter:card', content: 'summary_large_image' },
                { name: 'twitter:title', vmid: 'twitter:title', content: title },
                { name: 'twitter:description', vmid: 'twitter:description', content: description },
                { name: 'twitter:image', vmid: 'twitter:image', content: image },
                { name: 'twitter:url', vmid: 'twitter:url', content: canonicalUrl },
            ],
        }
    },
}
</script>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router/composables'
import DataLayer from '@services/data-layer/index'
import ShowScheduleMixBlock from '@components/show-schedule-mix-block'

const PLACEHOLDER_ROWS = 10
const HISTORY_LIMIT = 60

// channel.vue passes this down as `:channel="resource"`. It was never declared, so it landed in
// $attrs, `this.channel` in page() was undefined, and the view threw on every load.
defineProps({
    channel: {
        type: Object,
        default: () => ({}),
    },
    nowPlaying: {
        type: Object,
        default: () => ({}),
    },
})

const route = useRoute()

const stationsPlaylist = ref(
    Array.from(Array(PLACEHOLDER_ROWS), (_row, id) => ({
        id,
        mixes: {
            id,
            show: {
                id: '',
                title: '',
                url: '',
                type: '',
                image: {},
                genre: [],
                artist_id: {},
                artist: {},
            },
        },
    }))
)

const clientTimezoneLabel = computed(
    () => Intl.DateTimeFormat().resolvedOptions().timeZone || 'your local timezone'
)

onMounted(() => {
    const yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1)

    DataLayer.stationsPlaylists
        .get(route.params.channelId, yesterday, HISTORY_LIMIT, 0)
        .then(response => {
            const now = new Date()
            stationsPlaylist.value = response.body
                .filter(record => new Date(record.scheduled_start_time) < now)
                .reverse()
        })
})
</script>

<template>
    <BaseContent>
        <BaseSection
            title="History"
            padded
        >
            <p class="timezone-note">
                Showing times in {{ clientTimezoneLabel }}
            </p>
            <ShowScheduleMixBlock :resources="stationsPlaylist" />
        </BaseSection>
    </BaseContent>
</template>

<style lang="scss" scoped>
@import '@design';

.timezone-note {
    @extend %contentSubtitleS;

    margin: 0 0 $s-m;
    color: $c-shuttle-gray;
}
</style>
